"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getRouteInfo_exports = {};
__export(getRouteInfo_exports, {
  getRouteInfo: () => getRouteInfo,
  getRouteInfoFromState: () => getRouteInfoFromState
});
module.exports = __toCommonJS(getRouteInfo_exports);
var import_getPathFromState = require("../fork/getPathFromState");
var import_getStateFromPath_mods = require("../fork/getStateFromPath-mods");
var import_getNormalizedStatePath = require("./getNormalizedStatePath");
var import_isIndexPath = require("./isIndexPath");
var import_linkingConfig = require("./linkingConfig");
var import_path = require("./path");
function getRouteInfo(state) {
  return getRouteInfoFromState(function(state2, asPath) {
    var _getResolvedLinking;
    return (0, import_getPathFromState.getPathDataFromState)(state2, {
      screens: [],
      ...(_getResolvedLinking = (0, import_linkingConfig.getResolvedLinking)()) === null || _getResolvedLinking === void 0 ? void 0 : _getResolvedLinking.config,
      preserveDynamicRoutes: asPath,
      preserveGroups: asPath
    });
  }, state);
}
function getRouteInfoFromState(getPathFromState, state, baseUrl) {
  var { path } = getPathFromState(state, false);
  var qualified = getPathFromState(state, true);
  return {
    unstable_globalHref: path,
    // a hash href serializes as /page#section; the pathname the router compares
    // against pending navigation and the URL must drop the hash as well as the query
    pathname: (0, import_path.stripPathSuffix)((0, import_getStateFromPath_mods.stripBaseUrl)(path, baseUrl)),
    isIndex: (0, import_isIndexPath.isIndexPath)(state),
    ...(0, import_getNormalizedStatePath.getNormalizedStatePath)(qualified, baseUrl)
  };
}
//# sourceMappingURL=getRouteInfo.js.map
